import { type Question } from '@/types'

import { generateCOUNTIFS } from './generateCOUNTIFS'
import { generateIF } from './generateIF'
import { generateIFCOUNTIFS } from './generateIFCOUNTIFS'

type CheckFunctionTypeProps = 'IF' | 'COUNTIFS' | 'IFCOUNTIFS' | 'NONE'
const checkFunctionType = (input: string): CheckFunctionTypeProps => {
  let type: CheckFunctionTypeProps = 'NONE'

  if (/COUNTIFS.*IF/.test(input) || /IF.*COUNTIFS/.test(input)) {
    type = 'IFCOUNTIFS'
  } else if (input.startsWith('COUNTIFS')) {
    type = 'COUNTIFS'
  } else if (input.startsWith('IF')) {
    type = 'IF'
  }

  return type
}

export const generateHTMLFromFormula = (
  formula: string,
  questions: Question[]
) => {
  const functionType = checkFunctionType(formula)
  if (functionType === 'COUNTIFS') {
    return generateCOUNTIFS(questions, formula)
  }
  if (functionType === 'IF') {
    return generateIF(questions, formula)
  }
  if (functionType === 'IFCOUNTIFS') {
    return generateIFCOUNTIFS(questions, formula)
  }

  return ''
}
